import React from 'react';

import * as classes from './style.module.scss';

interface Props {
  image: string;
  name?: string;
  description?: string;
}

export const KeyCapabilities: React.FC<Props> = ({
  image,
  name,
  description,
}) => {
  return (
    <div className={classes.root}>
      <img className={classes.cardImage} src={image} alt="images" />
      <div className={classes.textWrapper}>
        <h3 className={classes.subHeading}>{name}</h3>
        {description}
      </div>
    </div>
  );
};
